// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__a1WF3","spin":"Loader_spin__ttWoh","sm":"Loader_sm__FbCyx","md":"Loader_md__er2AH","lg":"Loader_lg__mzuMr"};